/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fc_Tut_Sc8Inputs */

const en_fc_tut_sc8 = /** @type {(inputs: Fc_Tut_Sc8Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add edit at playhead`)
};

/**
* | output |
* | --- |
* | "Add edit at playhead" |
*
* @param {Fc_Tut_Sc8Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const fc_tut_sc8 = /** @type {((inputs?: Fc_Tut_Sc8Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fc_Tut_Sc8Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_fc_tut_sc8(inputs)
});
export { fc_tut_sc8 as "fc.tut.sc8" }